import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router";
import customClientAxios from "../customClientAxios";
import { FetchFormResponse } from "../Api/ApiEndPoints";
import { CustomTable } from "../Pages/OfferingBookings";
import TableHeaderStrip from "../Pages/Components/TableHeaderStrip";
import ResponseRow from "./ResponseRow";
import Loader from "../Pages/Components/Loader";

function FormResponses() {
  const { formId } = useParams();
  const [loading, setLoading] = useState(false);
  const [responses, setResponses] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();
  const limit = 30; // Number of items per page

  const lastResponseElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleGetFormResponses = async (pageNumber) => {
    try {
      setLoading(true);
      const doc = await customClientAxios().post(FetchFormResponse, {
        formId,
        page: pageNumber,
        limit,
      });

      if (pageNumber === 1) {
        setResponses(doc.data.response);
      } else {
        setResponses((prevResponses) => [
          ...prevResponses,
          ...doc.data.response,
        ]);
      }

      setHasMore(doc.data.response.length === limit);
    } catch (error) {
      console.error("Error fetching responses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetFormResponses(page);
  }, [page]);

  return (
    <CustomTable>
      <TableHeaderStrip
        list={[
          ["10%", "Customer Details"],
          ["10%", "Response Date"],
          ["10%", "Source"],
          ["10%", "Marked As Lead"],
          ["10%", "Responses"],
        ]}
      />
      {responses.map((response, index) => (
        <div
          key={response.responseId}
          ref={index === responses.length - 1 ? lastResponseElementRef : null}
        >
          <ResponseRow
            headerList={[
              ["10%", "Customer Details"],
              ["10%", "Response Date"],
              ["10%", "Source"],
              ["10%", "Marked As Lead"],
              ["10%", "Responses"],
            ]}
            source={response.source}
            response={response.formResponses}
            isLead={response.isLead}
            date={response.userActionDates.createdDate}
            responseId={response.responseId}
          />
        </div>
      ))}
      {loading && <Loader />}
    </CustomTable>
  );
}

export default FormResponses;
